import { createFileRoute } from '@tanstack/react-router'
import { ProcessDataWorkbench } from 'pages/processData/ProcessDataWorkbench'
import { processDataViewSearchSchema } from 'routes/process-data/-searchParams'

export const Route = createFileRoute('/process-data/view')({
  component: RouteComponent,
  validateSearch: processDataViewSearchSchema,
  staticData: {
    title: 'Process Data View',
    layout: {
      enableScrolling: false,
    },
  },
})

function RouteComponent() {
  const { orgId, siteId, alertId, sensorIds, start, end, mode, computedKey } =
    Route.useSearch()

  return (
    <ProcessDataWorkbench
      orgId={orgId}
      siteId={siteId}
      alertId={alertId}
      sensorIdsParam={sensorIds}
      start={start}
      end={end}
      mode={mode}
      computedKey={computedKey}
    />
  )
}
